// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.growth.listing.RentalManagerGrowthGetCompsForListingWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetCompsForListingResponseWebDto, ListingAlias } from '../..';

interface GetCompsParams {
  listingAlias: ListingAlias;
}

export const RentalManagerGrowthGetCompsForListingWebApiHandler_getComps_Path =
  '/api/web/v1/users/growth/listing/getComps';

/**
 * Get comps (geo + floorplans + similar floorplans) for a listing
 */
export const RentalManagerGrowthGetCompsForListingWebApiHandler_getComps = (
  getParams: GetCompsParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetCompsParams, never, GetCompsForListingResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerGrowthGetCompsForListingWebApiHandler_getComps_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
